module.exports = __webpack_public_path__ + "static/media/LittleSquirts.6729dc93.jpg";